import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const CommentIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 14"
  >
    <path d="M8 0C3.581 0 0 2.91 0 6.5c0 1.487.622 2.85 1.653 3.947-.465 1.231-1.434 2.275-1.45 2.287A.75.75 0 0 0 .75 14c1.922 0 3.438-.803 4.347-1.447A9.7 9.7 0 0 0 8 13c4.419 0 8-2.91 8-6.5S12.42 0 8 0m0 11.5a8.1 8.1 0 0 1-2.45-.378l-.71-.225-.609.431a6.7 6.7 0 0 1-1.796.906c.228-.378.45-.803.621-1.256l.332-.878-.644-.681C2.178 8.816 1.5 7.819 1.5 6.5c0-2.756 2.916-5 6.5-5s6.5 2.244 6.5 5-2.915 5-6.5 5" />
  </svg>
);
CommentIcon.id = 'CommentIcon';
CommentIcon.displayName = 'CommentIcon';
export default CommentIcon;
